import * as base64 from 'base-64';

const getHostUrl = (base64EncodedUrl: string) => {
    return base64.decode(base64EncodedUrl);
};

export default getHostUrl;
